"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityReverseFieldForm = exports.EntityReverseFieldFormDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var utils_1 = require("@shapeable/utils");
var react_animate_height_1 = __importDefault(require("react-animate-height"));
var use_entity_definition_1 = require("../../hooks/use-entity-definition");
var use_entities_1 = require("../../hooks/use-entities");
var form_v2_1 = require("../elements/form-v2");
var use_form_1 = require("../hooks/use-form");
var form_field_entity_select_1 = require("../elements/form-field-entity-select");
var field_container_1 = require("../../components/elements/field-container");
var entity_reverse_field_form_name_1 = require("../utils/entity-reverse-field-form-name");
var lodash_1 = require("lodash");
var record_to_array_1 = require("../utils/record-to-array");
var entity_value_1 = require("../../components/entities/entity-value");
var client_1 = require("@apollo/client");
var entity_reverse_field_query_1 = require("../../utils/entity-reverse-field-query");
var dialog_controls_1 = require("../elements/dialog-controls");
var icon_button_1 = require("../../components/elements/icon-button");
var use_lang_1 = require("../../hooks/use-lang");
var entity_update_mutation_field_name_1 = require("../../utils/entity-update-mutation-field-name");
var entity_create_mutation_field_name_1 = require("../../utils/entity-create-mutation-field-name");
var is_multi_field_1 = require("../utils/is-multi-field");
var loader_1 = require("../../components/elements/loader");
var cls = (0, utils_1.classNames)('entity-reverse-field-form');
exports.EntityReverseFieldFormDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: 100%;\n  "], ["\n    width: 100%;\n  "])))
});
var FormStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    width: 100%;\n    box-sizing: border-box;\n    padding: ", " ", " 0;\n    ", ";\n  "], ["\n    width: 100%;\n    box-sizing: border-box;\n    padding: ", " ", " 0;\n    ", ";\n  "])), theme_1.theme.UNIT(4), theme_1.theme.UNIT(4), theme_1.theme.H_DOT_BG('line-subtle'))
});
var ContextFieldsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    padding: ", ";\n    padding-bottom: 0;\n    box-sizing: border-box;\n    width: 100%;\n    ", ";\n  "], ["\n    padding: ", ";\n    padding-bottom: 0;\n    box-sizing: border-box;\n    width: 100%;\n    ", ";\n  "])), theme_1.theme.UNIT(4), theme_1.theme.H_DOT_BG('line-subtle'))
});
var FieldContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    padding-bottom: ", ";\n  "], ["\n    padding-bottom: ", ";\n  "])), theme_1.theme.UNIT(4))
});
var SelectStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ValueStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    padding: ", ";\n  "], ["\n    padding: ", ";\n  "])), theme_1.theme.UNIT(4))
});
var SubmitButtonStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n\n  "], ["\n\n  "])))
});
var LoaderStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Form: (0, styled_components_1.default)(form_v2_1.FormV2)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), FormStyles),
  SubmitButton: (0, styled_components_1.default)(icon_button_1.ContinueIconButton)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), SubmitButtonStyles),
  Loader: (0, styled_components_1.default)(loader_1.Loader)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), LoaderStyles),
  Value: (0, styled_components_1.default)(entity_value_1.EntityValue)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), ValueStyles),
  ContextFields: styled_components_1.default.div(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), ContextFieldsStyles),
  FieldContainer: (0, styled_components_1.default)(field_container_1.FieldContainer)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), FieldContainerStyles),
  Select: (0, styled_components_1.default)(form_field_entity_select_1.FormFieldEntitySelect)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), SelectStyles)
};
var EntityReverseFieldForm = function (props) {
  var className = props.className,
    children = props.children,
    entity = props.entity,
    fieldName = props.fieldName;
  var entities = (0, use_entities_1.useEntities)();
  var defn = (0, use_entity_definition_1.useEntityDefinition)(entity);
  var formName = (0, entity_reverse_field_form_name_1.entityReverseFieldFormName)(defn, fieldName);
  var form = (0, use_form_1.useForm)(formName);
  var t = (0, use_lang_1.useLang)();
  // --- START MEMO -->
  var _a = react_1.default.useMemo(function () {
      var _a;
      var reverseFieldDefn = (_a = defn === null || defn === void 0 ? void 0 : defn.form) === null || _a === void 0 ? void 0 : _a.reverseFields[fieldName];
      // source entity type definition - this is the direct reverse field from the entity being linked to (the other side of the relationship)
      var sourceDefn = entities[reverseFieldDefn === null || reverseFieldDefn === void 0 ? void 0 : reverseFieldDefn.entityTypeName];
      // reverse definition - this is the entity type which needs to be updated. It may be the same as the source, but it will be different if the source is a junction table
      var reverseDefn = entities[(reverseFieldDefn === null || reverseFieldDefn === void 0 ? void 0 : reverseFieldDefn.reverseEntityTypeName) || reverseFieldDefn.entityTypeName];
      // the field definition in the reverse entity type's set of fields
      var reverseEntityFieldDefn = reverseDefn === null || reverseDefn === void 0 ? void 0 : reverseDefn.form.fields[reverseFieldDefn.reverseEntityFieldName];
      // flag if a junction table is involved
      // if it is, we create a form for the junction table record to be filled out.
      // if not, we would be re-assigning the current entity to a different source entity 
      var isJunction = !!(reverseFieldDefn === null || reverseFieldDefn === void 0 ? void 0 : reverseFieldDefn.reverseEntityTypeName);
      // reverse field name is a temporary bucket to store in the form state, which will not be part of the mutation
      var reverseFieldName = reverseDefn === null || reverseDefn === void 0 ? void 0 : reverseDefn.singleTypeName.toLowerCase();
      var reverseEntityFieldName = reverseFieldDefn.reverseEntityFieldName || reverseFieldName;
      // fields are easier to process as an array, with the key as a name property
      var sourceFields = (0, record_to_array_1.recordToArrayWithName)(sourceDefn.form.fields);
      // find the source field in the source entity
      var sourceField = sourceFields.find(function (field) {
        return field.name === reverseFieldDefn.source;
      });
      // the source field must be set to the current entity value being viewed
      var sourceFieldValue = (0, is_multi_field_1.isMultiField)(sourceField) ? [entity.id] : entity.id;
      // setup an effect  
      // the source form fields are the fields of the source entity, minus the source field, which is pre-selected
      var sourceFieldsToInclude = (0, lodash_1.filter)(sourceFields, function (field) {
        return field.name !== (sourceField === null || sourceField === void 0 ? void 0 : sourceField.name);
      });
      var sourceFormFields = sourceFieldsToInclude.map(function (fieldSpec) {
        var field = __assign(__assign({}, fieldSpec), {
          type: fieldSpec.type || 'hidden',
          name: fieldSpec.name,
          label: fieldSpec.label || (0, lodash_1.startCase)(fieldSpec.name) || '',
          description: fieldSpec.description || '',
          required: fieldSpec.required
        });
        return field;
      });
      return {
        reverseFieldDefn: reverseFieldDefn,
        reverseEntityFieldDefn: reverseEntityFieldDefn,
        sourceDefn: sourceDefn,
        reverseDefn: reverseDefn,
        isJunction: isJunction,
        reverseFieldName: reverseFieldName,
        reverseEntityFieldName: reverseEntityFieldName,
        sourceField: sourceField,
        sourceFieldValue: sourceFieldValue,
        sourceFormFields: sourceFormFields
      };
    }, [entity, fieldName]),
    reverseFieldDefn = _a.reverseFieldDefn,
    reverseEntityFieldDefn = _a.reverseEntityFieldDefn,
    sourceDefn = _a.sourceDefn,
    reverseDefn = _a.reverseDefn,
    isJunction = _a.isJunction,
    reverseFieldName = _a.reverseFieldName,
    reverseEntityFieldName = _a.reverseEntityFieldName,
    sourceField = _a.sourceField,
    sourceFieldValue = _a.sourceFieldValue,
    sourceFormFields = _a.sourceFormFields;
  // -- END MEMO -->
  if (!defn) {
    console.error("EntityReverseFieldForm: entity definition not found", entity);
    return null;
  }
  if (!reverseFieldDefn) {
    console.error("EntityReverseFieldForm: field definition not found", entity, fieldName);
    return null;
  }
  if (!reverseDefn) {
    console.error("EntityReverseFieldForm: reverse entity definition not found", entity, fieldName, reverseFieldDefn);
    return null;
  }
  if (!reverseEntityFieldDefn) {
    console.error("EntityReverseFieldForm: reverse entity field definition not found", entity, fieldName);
    return null;
  }
  // initialize the form
  react_1.default.useEffect(function () {
    form.patch({
      canSubmit: function () {
        return false;
      }
    });
  }, []);
  // ---- setup mutations
  var _b = __read((0, client_1.useMutation)(sourceDefn.create.mutation, {
      onError: function (error) {
        throw new Error(error.message);
      }
    }), 2),
    createSource = _b[0],
    _c = _b[1],
    createSourceLoading = _c.loading,
    createSourceData = _c.data;
  var _d = __read((0, client_1.useMutation)(reverseDefn.update.mutation, {
      onError: function (error) {
        throw new Error(error.message);
      }
    }), 2),
    updateReverse = _d[0],
    _e = _d[1],
    updateReverseLoading = _e.loading,
    updateReverseData = _e.data;
  var reverseFieldQueryFields = reverseFieldDefn.reverseEntityFieldName ? "".concat(reverseFieldDefn.reverseEntityFieldName, " { id }") : '';
  // ---- setup reverse field query, which will insert the id of the result of the source item mutation
  var REVERSE_FIELD_QUERY = (0, entity_reverse_field_query_1.entityReverseFieldQuery)(reverseDefn, reverseFieldQueryFields);
  var _f = __read((0, client_1.useLazyQuery)(REVERSE_FIELD_QUERY, {
      fetchPolicy: "no-cache"
    }), 2),
    loadReverseEntity = _f[0],
    _g = _f[1],
    loading = _g.loading,
    reverseFieldQueryData = _g.data;
  var canSubmit = form.canSubmit() && form.isValid;
  var reverseEntity = reverseFieldQueryData === null || reverseFieldQueryData === void 0 ? void 0 : reverseFieldQueryData[reverseDefn.updateTypeName];
  var createSourceEntity = createSourceData === null || createSourceData === void 0 ? void 0 : createSourceData[(0, entity_create_mutation_field_name_1.entityCreateMutationFieldName)(sourceDefn)];
  var updateReverseEntity = updateReverseData === null || updateReverseData === void 0 ? void 0 : updateReverseData[(0, entity_update_mutation_field_name_1.entityUpdateMutationFieldName)(reverseDefn)];
  var handleSourceFieldChange = function (result) {
    return __awaiter(void 0, void 0, void 0, function () {
      var _a;
      return __generator(this, function (_b) {
        form.patch({
          fields: (_a = {}, _a[reverseFieldName] = result, _a)
        });
        // fire off the reverse query
        loadReverseEntity({
          variables: {
            id: result.mutationValue
          }
        });
        return [2 /*return*/];
      });
    });
  };
  // --- 1. listen for the reverse entity being loaded
  react_1.default.useEffect(function () {
    // when the reverseEntity is available, we can now submit
    form.patch({
      canSubmit: function () {
        return !!reverseEntity;
      }
    });
  }, [reverseEntity]);
  // console.log("REVERSE ENTITY", reverseEntity);
  // --- 2. listen for submisssion
  var handleSubmitClick = function () {
    // This is the mutation input for the source entity that will be created.
    // This is the junction table, when a junction is involved.
    var _a;
    var sourceCreateMutationInput = __assign(__assign({}, (0, lodash_1.omit)(form.mutationValue, reverseFieldName)), (_a = {
      name: "".concat(sourceDefn.name, " - ").concat(entity.name, " - ").concat(reverseEntity.name)
    }, _a[sourceField.name] = sourceFieldValue, _a));
    // console.log("SOURCE DEFN NAME", sourceDefn.name);
    // console.log("SOURCE CREATE MUTATION INPUT", sourceCreateMutationInput);
    // we don't need to await this one, as we are listening via an effect 
    createSource({
      variables: {
        input: sourceCreateMutationInput
      }
    });
  };
  // --- 3. Listen for the source record being created
  react_1.default.useEffect(function () {
    var _a;
    // as long as we have a result, now we can update the reverse entity
    if (createSourceEntity === null || createSourceEntity === void 0 ? void 0 : createSourceEntity.id) {
      var isMultiple = (0, is_multi_field_1.isMultiField)(reverseEntityFieldDefn);
      // TODO we probably should load this again here, in case somebody else is updating it 
      var reverseEntityFieldValue = reverseEntity[reverseEntityFieldName];
      var reverseUpdateMutationInput = (_a = {},
      // if the reverse entity field is single, the result will replace the existing value (should this even be allowed?) 
      _a[reverseEntityFieldName] = isMultiple ? __spreadArray(__spreadArray([], __read((reverseEntityFieldValue || []).map(function (item) {
        return item.id;
      })), false), [createSourceEntity.id], false) : createSourceEntity.id, _a.name = reverseEntity.name, _a);
      // console.log("REVERSE DEFN NAME", reverseDefn.name);
      // console.log("REVERSE UPDATE MUTATION INPUT", reverseUpdateMutationInput);
      // console.log("REVERSE MUTATION ID", reverseEntity.id);
      updateReverse({
        variables: {
          id: reverseEntity.id,
          input: reverseUpdateMutationInput
        }
      });
    }
  }, [createSourceEntity]);
  // --- 4. Listen for the reverse record being updated
  react_1.default.useEffect(function () {
    if (updateReverseEntity === null || updateReverseEntity === void 0 ? void 0 : updateReverseEntity.id) {
      // now we can close the dialog
      if (props.onComplete) {
        props.onComplete({
          sourceEntity: createSourceEntity,
          reverseEntity: updateReverseEntity
        });
      }
    }
  }, [updateReverseEntity]);
  // the reverse form field is first selected by the user which will then allow the source record to be fill out
  // e.g. assigning a person to an organisation would first require selecting the organisation (the reverse), then they would 
  // fill out an OrganisationRole form (the source)
  var reverseFormField = {
    name: reverseFieldName,
    label: reverseDefn.label,
    description: "Select the {{".concat(reverseDefn.templatePlaceholder, "}} to assign this ").concat(sourceDefn.label, " to"),
    required: true,
    autoFocus: true,
    onChange: handleSourceFieldChange
  };
  var reverseFieldState = form.fields[reverseFieldName];
  var isLoading = updateReverseLoading || createSourceLoading;
  return react_1.default.createElement(My.Container, {
    className: cls.name(className)
  }, react_1.default.createElement(My.Value, {
    entity: entity,
    alwaysShowIcon: false
  }), react_1.default.createElement(My.ContextFields, null, react_1.default.createElement(My.FieldContainer, {
    marginless: true,
    field: reverseFormField
  }, react_1.default.createElement(My.Select, {
    name: reverseFieldName,
    entityTypeName: reverseDefn.name,
    value: reverseFieldState === null || reverseFieldState === void 0 ? void 0 : reverseFieldState.value,
    onChange: handleSourceFieldChange
  }))), react_1.default.createElement(react_animate_height_1.default, {
    duration: 300,
    height: (reverseFieldState === null || reverseFieldState === void 0 ? void 0 : reverseFieldState.value) ? 'auto' : 0
  }, isJunction && react_1.default.createElement(My.Form, {
    className: cls.name('form'),
    name: formName,
    fields: sourceFormFields
  })), react_1.default.createElement(dialog_controls_1.DialogControls, null, isLoading ? react_1.default.createElement(My.Loader, {
    spaceUnits: 3,
    spinnerSize: 16
  }, t('Please Wait...')) : react_1.default.createElement(My.SubmitButton, {
    disabled: !canSubmit,
    onClick: handleSubmitClick
  }, t('Submit'))));
};
exports.EntityReverseFieldForm = EntityReverseFieldForm;
exports.EntityReverseFieldForm.defaultProps = exports.EntityReverseFieldFormDefaultProps;
exports.EntityReverseFieldForm.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16;